import { render, staticRenderFns } from "./landpage.vue?vue&type=template&id=3e9f5bb0&scoped=true"
import script from "./landpage.vue?vue&type=script&lang=js"
export * from "./landpage.vue?vue&type=script&lang=js"
import style0 from "./landpage.vue?vue&type=style&index=0&id=3e9f5bb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e9f5bb0",
  null
  
)

export default component.exports